class AnnotationBySentenceFormatter {
	constructor(ListAnnotation) {
		this.ListAnnotation = ListAnnotation
		this.listOfOccurenceTerm = []
		this.newListAnnotation = []
		this.currentAnnotation = {}
		this.currentIndexInLine = 0
		this.lastEndWordIndex = 0
	}

	initializeCurrentAnnotation(indexInSentence) {
		let term_text = ''
		let termIds = []

		for (let term of this.listOfOccurenceTerm) {
			termIds.push(term.term_id)
			term_text += term.term_text + '\n'
		}

		this.currentAnnotation = { termIds, term_text, segment_start: indexInSentence }
	}

	pushCurrentAnnotation(indexInSentence) {
		this.currentAnnotation.segment_end = indexInSentence
		this.newListAnnotation.push(this.currentAnnotation)
	}

	checkEndWord(indexInSentence, sentence_text) {
		if (sentence_text[indexInSentence] === ' ') {
			this.lastEndWordIndex = indexInSentence
		}
	}

	lineFeed() {
		const maxLineSize = 125
		if (this.currentIndexInLine === maxLineSize && this.currentAnnotation?.termIds) {
			this.pushCurrentAnnotation(this.lastEndWordIndex)
			this.initializeCurrentAnnotation(this.lastEndWordIndex)
			this.currentIndexInLine = 0
		}
	}

	annotationSegmentStart(annotation, indexInSentence) {
		//if there is already an annatotation we push it and initialize a new one with the new term
		if (this.currentAnnotation?.termIds) {
			if (this.currentAnnotation.segment_start !== indexInSentence) this.pushCurrentAnnotation(indexInSentence)
			this.initializeCurrentAnnotation(indexInSentence)
			this.currentIndexInLine = 0
			// else we initialize a new annotation
		} else {
			this.currentAnnotation = { termIds: [annotation.term_id], term_text: annotation.term_text, segment_start: annotation.segment_start }
			this.currentIndexInLine = 0
		}
	}

	annotationSegmentEnd(indexInSentence) {
		if (this.newListAnnotation[this.newListAnnotation.length - 1]?.segment_end !== indexInSentence) {
			this.pushCurrentAnnotation(indexInSentence)
			this.currentIndexInLine = 0
		}
		//we remove all the term where there annotation ended
		for (let term of this.listOfOccurenceTerm) {
			if (term.segment_end === indexInSentence) {
				this.listOfOccurenceTerm.splice(this.listOfOccurenceTerm.indexOf(term), 1)
			}
		}
		//if there is no more term there is no annotation
		if (this.listOfOccurenceTerm.length === 0) {
			this.currentAnnotation = {}
			//else we initialize a new annotation
		} else {
			this.initializeCurrentAnnotation(indexInSentence)
		}
	}

	checkAnnotation(indexInSentence) {
		for (let annotation of this.ListAnnotation) {
			//if a new annotation appear we add the term to the term list
			if (indexInSentence === annotation.segment_start) {
				this.listOfOccurenceTerm.push({ term_id: annotation.term_id, term_text: annotation.term_text, segment_end: annotation.segment_end })

				this.annotationSegmentStart(annotation, indexInSentence)
			} else if (indexInSentence === annotation.segment_end) {
				//if one of the current term's annotation ended we push the annotation
				this.annotationSegmentEnd(indexInSentence)
			}
		}
	}

	removeUselessAnnotation(sentence_text) {
		//remove annotation based on a space only
		for (let annotation of this.newListAnnotation) {
			if (annotation.segment_end - annotation.segment_start === 1 && sentence_text[annotation.segment_start] === ' ') {
				this.newListAnnotation.splice(this.newListAnnotation.indexOf(annotation), 1)
			}
		}
	}

	getAnnotationBySentence(sentence) {
		for (let i = 0; i < sentence.sentence_text.length; i++) {
			//if the line is too big we split the annotation in two
			this.checkEndWord(i, sentence.sentence_text)
			this.lineFeed()

			this.checkAnnotation(i)

			this.currentIndexInLine += 1
		}
		if (this.currentAnnotation?.termIds) {
			this.pushCurrentAnnotation(sentence.sentence_text.length)
		}
		this.removeUselessAnnotation(sentence.sentence_text)

		return this.newListAnnotation
	}
}

export default AnnotationBySentenceFormatter
